import { render, staticRenderFns } from "./ProductOverall.vue?vue&type=template&id=f929ac76&scoped=true"
import script from "./ProductOverall.vue?vue&type=script&lang=js"
export * from "./ProductOverall.vue?vue&type=script&lang=js"
import style0 from "./ProductOverall.vue?vue&type=style&index=0&id=f929ac76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f929ac76",
  null
  
)

export default component.exports